<template>
  <table class="invoice-product--table mt-50 product-details">
    <thead class="invoice-product--thead">
      <tr class="invoice-product--header">
        <th class="invoice-product--col5">Product & Description</th>
        <th class="invoice-product--col3">Term</th>
        <th class="invoice-product--col2">Quantity</th>
        <th class="invoice-product--col2 text-right">Amount</th>
      </tr>
    </thead>
    <tbody class="invoice-product--tbody" v-if="products">
      <InvoiceProductItem
        v-for="(product, index) of products"
        :key="product.id"
        :product="product"
        :index="index"
      />
    </tbody>
  </table>
</template>

<script>
import InvoiceProductItem from "./InvoiceProductItem";
export default {
  components: {
    InvoiceProductItem
  },
  props: {
    products: {
      type: [Array],
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
.invoice-product {
  &--table {
    width: 100%;
    th,
    td {
      font-family: "Arial";
      padding: 20px 0;
    }
  }
  &--col {
    &1 {
      width: 8.333333%;
    }
    &2 {
      width: 16.66667%;
    }
    &3 {
      width: 25%;
    }
    &4 {
      width: 33.33333%;
    }
    &5 {
      width: 41.66667%;
    }
  }
  &--header {
    border-bottom: 4px solid #cccccc;
    th {
      color: #232323;
      font-size: 16px;
      font-family: "Arial";
      padding: 20px 0;
    }
  }
}
</style>
